import { useState } from 'react';
import { cn } from '@/lib/utils';

/**
 * Wrap content to add a subtle grid that illuminates around the cursor.
 * Intended for dark sections.
 */
export const HoverGrid = ({ className, children }) => {
  const [pos, setPos] = useState({ x: -100, y: -100 });

  const onMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  return (
    <div
      className={cn('relative overflow-hidden', className)}
      onMouseMove={onMove}
      onMouseLeave={() => setPos({ x: -100, y: -100 })}
    >
      {children}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, rgba(148, 163, 184, 0.06), rgba(148, 163, 184, 0.06) 1px, transparent 1px, transparent 16px),
            repeating-linear-gradient(90deg, rgba(148, 163, 184, 0.06), rgba(148, 163, 184, 0.06) 1px, transparent 1px, transparent 16px)
          `,
          maskImage: `radial-gradient(180px at ${pos.x}px ${pos.y}px, rgba(0,0,0,1), rgba(0,0,0,0))`,
          WebkitMaskImage: `radial-gradient(180px at ${pos.x}px ${pos.y}px, rgba(0,0,0,1), rgba(0,0,0,0))`,
          opacity: pos.x < 0 ? 0 : 1,
          transition: 'opacity 120ms ease-out',
        }}
      />
    </div>
  );
};
